/* Progressively enhance Ghost pagination; retain normal links on request failure. */
(function () {
    'use strict';
    var next = document.querySelector('link[rel="next"]');
    var feed = document.querySelector('.post-feed');
    var pagination = document.querySelector('.pagination');
    if (!next || !feed || !pagination || !('IntersectionObserver' in window)) return;
    var loading = false;
    var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || loading || !next) return;
        loading = true;
        feed.setAttribute('aria-busy', 'true');
        fetch(next.href).then(function (response) {
            if (!response.ok) throw new Error('Unable to load the next page');
            return response.text();
        }).then(function (html) {
            var page = new DOMParser().parseFromString(html, 'text/html');
            var cards = page.querySelectorAll('.post-feed > .post-card');
            if (!cards.length) throw new Error('No articles returned');
            cards.forEach(function (card) {
                card.classList.remove('post-card-large');
                feed.appendChild(document.importNode(card, true));
            });
            next = page.querySelector('link[rel="next"]');
            var newPagination = page.querySelector('.pagination');
            if (newPagination) pagination.innerHTML = newPagination.innerHTML;
            if (!next) {observer.disconnect(); pagination.hidden = true;}
        }).catch(function () {
            observer.disconnect();
        }).finally(function () {
            loading = false;
            feed.removeAttribute('aria-busy');
        });
    }, {rootMargin: '300px'});
    observer.observe(pagination);
})();
